module.exports = __webpack_public_path__ + "static/media/Eyes_blue.16680912.svg";